export default {
  computed: {
    permissions() {
      return this.$store.getters.permissions
    }
  },

  methods: {
    hasPermission(permission) {
      return Boolean(this.permissions.includes(permission))
    }
  }
}
